module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_studio_plans-a4095c5337ae35dab2b197080b99695c.jpg";